import comp from "./PictureInPicture";
export default comp;
